import React, { useEffect } from 'react';
import Grid from '@mui/material/Grid';
import { Button } from '@mui/material';

const LANGUAGE_OPTIONS = [
  { code: 'en', text: 'ENG' },
  { code: 'zh-Hant-HK', text: '繁中' },
  { code: 'zh', text: '简中' }
];

const LanguageButtons = props => {
  const { value, onChange, className, ...rest } = props;

  const createOnClickHandler = option => () => onChange({ target: { name: 'language', value: option.code } });

  useEffect(() => {
    if (value) {
      onChange({ target: { name: 'language', value } });
    }
  }, []);

  return (
    <Grid
      className={`language-buttons${className ? ` ${className}` : ''}`}
      container
      {...rest}
      sx={[{
        justifyContent: "flex-start"
      }, ...(Array.isArray(rest.sx) ? rest.sx : [rest.sx])]}>
      {LANGUAGE_OPTIONS.map(option => (
        <Grid key={option.code}>
          <Button
            variant="contained"
            color="primary"
            className={`${value === option.code ? 'selected' : ''}`}
            style={{
              backgroundColor: value === option.code ? '#3966f8' : '#fff',
              color: value === option.code ? '#fff' : '#3966f8'
            }}
            onClick={createOnClickHandler(option)}
          >
            {option.text}
          </Button>
        </Grid>
      ))}
    </Grid>
  );
};

export default LanguageButtons;
